export { default } from './WorkDetails';
